import { 
  INSTALL_FONTS
} from '../constants/actionTypes';

import { createAction } from 'redux-actions';

export const installFonts = createAction(INSTALL_FONTS, (fonts) => {
  return fonts;
});
